/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   18/10/2022
 */

import React, { ErrorInfo } from "react";
import { Link, Stack } from "@mui/material";
import Const from "./const.json";
import { getDataUrl } from "./context/environment";
import HeroMessage from "./components/HeroMessage";

export default class ErrorBoundary extends React.Component {

	state = {
		hasError: false
	};

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		fetch(getDataUrl() + "/graphql", {
			method: "POST",
			mode: "cors",
			credentials: "include",
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				query: 'mutation LogClientSideError($error: JSON!) { logClientSideError(error: $error) }',
				variables: {
					error: {
						message: error.message,
						stack: error.stack,
						info: errorInfo
					}
				}
			})
		}).then((r) => console.log(r));
		console.error(error, errorInfo);
	}

	render() {
		if (this.state.hasError) {
			return (
				<Stack sx={{ width: "100%", p: 10}}>
					<HeroMessage
						title={"Houston, we have a problem"}
						message={
						<>
							<p>Something went terribly terribly wrong and the app has crashed.</p>
							<p>Please report this problem to <Link href={Const.URL_SLACK_CHANNEL} target={"_blank"}>{Const.SLACK_CHANNEL_NAME}</Link> to get fixed.</p>
						</>
						}
					/>
				</Stack>
			);
		}

		return this.props.children;
	}
}